import en from './en.json'
import it from './it.json'

export const esclusiveTranslations = {
	en,
	it
} as const
